import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import DatePicker from "react-datepicker"
import { Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'

import ReactSelect from 'pages/parts/ReactSelect'
import usePreventExit from "pages/parts/usePreventExit"
import { httpOk, GET, POST, PUT } from 'helpers/api'
import { formatDate, formatMoney, returnMinDate, formatMoneyInput } from 'helpers/helpers'
import CustomTooltip from 'pages/parts/CustomTooltip'

function CreateUpdate() {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const [isDirty, setIsDirty] = useState(false);
	usePreventExit(isDirty);

	const tbodyRef = useRef()
	const scrollRef = useRef()

	const reduxAccount = useSelector(state => state.account)
	const reduxSettings = useSelector(state => state.settings)

	const [data, setData] = useState({
		"items": [],
		"wms_id": reduxAccount.wms_id,
		"supplier_id": null,
		"total_amount": 0,
		"total_amount_usd": 0,
		"bool_annual": false,
		"created_at": formatDate(new Date(), 'yyyy-MM-dd'),
	})
	const [elements, setElements] = useState([])
	const [elementsDuplicate, setElementsDuplicate] = useState([])
	const [wms, setWms] = useState([])
	const [suppliers, setSuppliers] = useState([])
	const [modalConfirm, setModalConfirm] = useState(false)

	async function createUpdate(stage = 1) {
		var dataCopy = structuredClone(data)

		if (dataCopy.items.length === 0) {
			toast.error(t('add_elements'))
			return
		}

		for (let i = 0; i < dataCopy.items.length; i++) {
			if (!dataCopy.items[i]['quantity']) {
				dataCopy.error = true
			}
			if (dataCopy.items[i]['price'] === "" || dataCopy.items[i]['price'] < 0.0001) {
				dataCopy.error = true
			}
			dataCopy.items[i]['price'] = Number(dataCopy.items[i]['price']) / Number(reduxSettings.currency);
			dataCopy.items[i]['wholesale_price'] = Number(dataCopy.items[i]['wholesale_price']) / Number(reduxSettings.currency);
			dataCopy.items[i]['sale_price'] = Number(dataCopy.items[i]['sale_price']) / Number(reduxSettings.currency);
			// if (dataCopy.items[i]['product_type'] === 1) {
			// 	dataCopy.items[i]['supplier_price'] = Number(dataCopy.items[i]['supplier_price']) / Number(reduxSettings.currency);
			// }
		}
		console.log(dataCopy.items);
		if (dataCopy.error) {
			toast.error(t('check_filled_inputs'))
			return
		}

		if (stage === 1 || stage === 2) {
			setModalConfirm(true)
			return
		}

		var response;
		if (dataCopy.id) {
			response = await PUT('/documents-in', dataCopy, { loader: true })
		} else {
			response = await POST('/documents-in', dataCopy, { loader: true })
		}

		if (httpOk(response)) {
			navigate('/documents-in')
		}
	}

	function addToList(length = 1) {
		var dataCopy = JSON.parse(JSON.stringify(data))

		for (let i = 0; i < length; i++) {
			dataCopy.items.push({
				'price': '',
				'wholesale_price': '',
				'sale_price': '',
				'product_id': '',
				'quantity': '',
				'unit_quantity': '',
			})
		}

		setIsDirty(true)
		calculate(dataCopy)

		setTimeout(() => {
			const byId = document.getElementById(`input-select-${dataCopy.items.length}`)
			byId?.select()
		}, 200);
	}

	function deleteItem(index) {
		var dataCopy = JSON.parse(JSON.stringify(data))
		dataCopy.items.splice(index, 1)

		calculate(dataCopy)
	}

	function handleInputChange(e, index) {
		var dataCopy = { ...data }

		dataCopy.items[index][e.target.name] = e.target.value.replace(/[^0-9.]/g, '')
		if (e.target.name === "packaging_quantity" || e.target.name === "expense" || e.target.name === "original_quantity" || e.target.name === "original_price") {
			dataCopy.items[index]["quantity"] = Number(dataCopy.items[index]["packaging_quantity"]) * Number(dataCopy.items[index]["unit_quantity"])

			if (dataCopy.items[index]['product_type'] === 2) {
				dataCopy.items[index]["total_supplier_price"] = Number((dataCopy.items[index]["original_quantity"] * dataCopy.items[index]["original_price"]))

				if (dataCopy.items[index]["quantity"]) {
					dataCopy.items[index]["price_usd"] = (
						((dataCopy.items[index]["total_supplier_price"]) / Number(dataCopy.items[index]["quantity"] ?? 0)) * 100) / 100;
				} else {
					dataCopy.items[index]["price_usd"] = 0;
				}

				dataCopy.items[index]["price"] = Math.round(Number(dataCopy.items[index]["price_usd"]) * Number(reduxSettings.currency));
				dataCopy.items[index]["price"] = Math.round(Number(dataCopy.items[index]["price"]) + Number(dataCopy.items[index]["expense"] ?? 0));


				dataCopy.items[index]["supplier_price"] =
					((dataCopy.items[index]["total_supplier_price"] / dataCopy.items[index]["quantity"]) * 100) / 100;
			}
			if (dataCopy.items[index]["product_type"] === 1) {
				// if (dataCopy.items[index]["original_price"] && dataCopy.items[index]["quantity"]) {	
				// 	dataCopy.items[index]["price"] = dataCopy.items[index]["original_price"] * Number(reduxSettings.currency) / dataCopy.items[index]["quantity"];
				// } else {
				// 	dataCopy.items[index]["price"] = 0;
				// }
				dataCopy.items[index]["total_supplier_price"] = dataCopy.items[index]["original_price"] * dataCopy.items[index]["quantity"];
				dataCopy.items[index]["price"] = dataCopy.items[index]["original_price"] * Number(reduxSettings.currency);
			}
		}

		if (dataCopy.items[index]["product_type"] === 1 && Number(dataCopy.items[index]["price"]) > 0) {
			dataCopy.items[index]["supplier_price"] = dataCopy.items[index]["price"] / Number(reduxSettings.currency)
			dataCopy.items[index]["total_price"] = Number((Number(dataCopy.items[index]["quantity"]) * Number(dataCopy.items[index]["sale_price"])));
		}

		if (e.target.name === "price" && !dataCopy.items[index]["price"]) {
			dataCopy.items[index]["total_price"] = 0
		}

		if (e.target.name === "sale_price" && dataCopy.items[index]["price"]) {
			dataCopy.items[index]["markup"] = ((dataCopy.items[index]["sale_price"] - dataCopy.items[index]["price"]) / dataCopy.items[index]["price"]).toFixed(2) * 100;
		}

		if (e.target.name === "markup" && dataCopy.items[index]["price"]) {
			dataCopy.items[index]["sale_price"] = (dataCopy.items[index]["price"] * (1 + dataCopy.items[index]["markup"] / 100)).toFixed(0);
		}

		if (e.target.name === "total_price") {
			dataCopy.items[index]["total_price"] =
				Number(dataCopy.items[index]["total_price"]).toFixed(2);
			dataCopy.items[index]["price"] =
				Number((Number(dataCopy.items[index]["total_price"]) / Number(dataCopy.items[index]["quantity"])).toFixed(2));
		} else {
			dataCopy.items[index]["total_price"] = Number((dataCopy.items[index]["quantity"] * dataCopy.items[index]["sale_price"]
			)) + Number((dataCopy.items[index]["expense"] ?? 0))

		}

		calculate(dataCopy)
	}

	function calculate(dataCopy) {
		dataCopy.total_amount = 0
		dataCopy.total_quantity = 0
		dataCopy.total_amount_usd = 0
		for (let i = 0; i < dataCopy.items.length; i++) {
			dataCopy.total_quantity += Number(dataCopy.items[i]['quantity'])
			dataCopy.total_amount += Number(dataCopy.items[i]['quantity']) * Number(dataCopy.items[i]['sale_price'])
			if (dataCopy.items[i]['product_type'] === 1) {
				dataCopy.total_amount_usd += Number(dataCopy.items[i]['original_price']) * Number(dataCopy.items[i]['quantity'])
			} else {
				dataCopy.total_amount_usd += Number(dataCopy.items[i]['original_quantity']) * Number(dataCopy.items[i]['original_price'])
			}
		}

		setData(dataCopy)
	}

	// REACTSELECT LOGIC
	function handleSelectSearch(value) {
		if (value === '+' || value === '=') return
		if (!value || value === '+' || value === '=') {
			setElements([...elementsDuplicate])
			return
		}
		var elementsDuplicateCopy = [...elementsDuplicate]

		var filteredItems = elementsDuplicateCopy.filter(item => item.name.toLowerCase().includes(value.toLowerCase()))
		if (filteredItems[0]) {
			filteredItems[0]['selected'] = true
		}
		setElements(filteredItems)
	}

	function handleSelectProduct(option, index) {
		var dataCopy = { ...data }
		dataCopy.items[index]['product_id'] = option.id
		dataCopy.items[index]['name'] = option.name
		dataCopy.items[index]['balance_id'] = option.balance_id
		dataCopy.items[index]['balance'] = option.balance
		dataCopy.items[index]['unit_name'] = option.unit_name
		dataCopy.items[index]['units'] = option.units
		dataCopy.items[index]['product_type'] = option.product_type
		dataCopy.items[index]['total_price'] = ""
		dataCopy.items[index]['packaging_quantity'] = ""
		dataCopy.items[index]['unit_quantity'] = 1

		if (dataCopy.items[index]['product_type'] === 1) {
			dataCopy.items[index]['price'] = option.price
			dataCopy.items[index]['wholesale_price'] = option.wholesale_price
			dataCopy.items[index]['sale_price'] = option.sale_price
		}

		setData(dataCopy)
	}

	function closeReactSelect() {
		setTimeout(() => {
			var elementsCopy = [...elements]
			for (let i = 0; i < elementsCopy.length; i++) {
				elementsCopy[i]['selected'] = false
			}
			if (elementsCopy[0] && elementsCopy[0]['selected'])
				elementsCopy[0]['selected'] = true
			setElements(elementsCopy)
		}, 100);
	}

	function handleTableKeyDown(event) {
		event.stopPropagation();
		var currentIndex = elements.findIndex(el => el.selected);
		if (currentIndex >= 0) {
			var elementsCopy = [...elements]
			elementsCopy[currentIndex].selected = false
			switch (event.key) {
				case "ArrowUp":
					if (currentIndex === 0) {
						elementsCopy[elements.length - 1].selected = true
						currentIndex = elements.length - 1
					} else {
						elementsCopy[currentIndex - 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6) - 59.2
					break;
				case "ArrowDown":
					if (currentIndex === elements.length - 1) {
						elementsCopy[0].selected = true
						currentIndex = 0
					} else {
						elementsCopy[currentIndex + 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6)
					break;
				default: break;
			}

			setElements(elementsCopy)
		}
	}

	async function getWms() {
		const response = await GET(`/helper/wms`, {}, { loader: true })
		if (httpOk(response)) setWms(response.data)
	}

	async function getSuppliers() {
		const response = await GET('/helper/suppliers', {}, { loader: true })
		if (httpOk(response)) setSuppliers(response.data)
	}

	async function getProducts(wmsId) {
		const response = await GET(`/documents-in-products?wms_id=${wmsId}`, {}, { loader: true })
		if (httpOk(response)) {
			setElements(response.data)
			setElementsDuplicate(response.data)
		}
	}

	useEffect(() => {
		getWms()
		getSuppliers()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="d-flex text-truncate">
					<h4 className="vertical-center">
						{t('good_reception')}
					</h4>
					<div className="vertical-center mt-1">
						<i className="uil uil-angle-double-right fz-20"></i>
					</div>
					<div className="vertical-center mt-1">
						<h6>{t('create')}</h6>
					</div>
				</div>
			</div>

			<form autoComplete="off">
				<div className="card mb-3">
					<div className="card-body">
						<div className="row">
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('date')}<span className="required-mark">*</span></label>
									<div className="calendar-input">
										<DatePicker
											className="form-control"
											dateFormat="dd.MM.yyyy"
											selected={data.created_at ? new Date(data.created_at) : ''}
											onChange={(date) => setData({ ...data, 'created_at': formatDate(date, 'yyyy-MM-dd') })}
											minDate={returnMinDate(new Date(), reduxAccount.backdate ?? 3)}
											maxDate={new Date()} />
										<i className="uil uil-calendar-alt"></i>
									</div>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('warehouse')}<span className="required-mark">*</span></label>
									<Select
										options={wms}
										value={wms.find(option => option.id === data.wms_id)}
										onChange={(option) => {
											setData({ ...data, 'wms_id': option.id })
											getProducts(option.id)
										}}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('supplier')}<span className="required-mark">*</span></label>
									<Select
										options={suppliers}
										value={suppliers.find(option => option.id === data.supplier_id)}
										onChange={(option) => setData({ ...data, 'supplier_id': option.id })}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('note')}</label>
									<input type="text" className="form-control"
										name="note"
										onChange={(e) => setData({ ...data, 'note': e.target.value })} />
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="card">
					<div className="card-body">
						<table className="table table-bordered" style={{ 'overflow': 'unset' }}>
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '30%' }}>{t('name2')}</th>
									<th style={{ 'minWidth': '60px' }} className="text-end">{t('id')}</th>
									<th style={{ 'minWidth': '60px' }} className="text-end">{t('balance2')}</th>
									{/* <th style={{ 'width': '10%' }} className="text-start td-ellipsis">{t('unit')}</th> */}
									<th style={{ 'minWidth': '60px' }} className="text-end">{t('tonna')}</th>
									<th style={{ 'minWidth': '70px' }} className="text-end">{t('price')}</th>
									<th style={{ 'minWidth': '60px' }} className="text-end">
										{t('metr')}<span className="required-mark">*</span>
									</th>
									<th style={{ 'minWidth': '60px' }} className="text-end">
										<CustomTooltip text={`${t('quantity')} / 1200 * 1000`}>
											{t('1м-кг')}
										</CustomTooltip>
									</th>
									<th style={{ 'minWidth': '60px' }} className="text-end">
										<CustomTooltip text={`1200 / ${t('quantity')}`}>
											{t('1т-м')}
										</CustomTooltip>
									</th>
									<th style={{ 'width': '10%' }} className="text-end">
										{t('fact')}
									</th>
									<th>{t('expense')}</th>
									{/* <th style={{ 'minWidth': '90px' }} className="text-end td-ellipsis"
										title={t('supplier_price')}>
										{t('supplier_price')}<span className="required-mark">*</span>
									</th> */}
									<th style={{ 'minWidth': '90px' }} className="text-end td-ellipsis">
										{t('arrival_price')}<span className="required-mark">*</span>
									</th>
									<th style={{ 'minWidth': '90px' }} className="text-end td-ellipsis">
										{t('wholesale_price')}<span className="required-mark">*</span>
									</th>
									<th style={{ 'minWidth': '90px' }} className="text-end td-ellipsis">
										{t('sale_price')}<span className="required-mark">*</span>
									</th>
									<th style={{ 'minWidth': '50px' }} className="text-end">
										{t('markup')}%
									</th>
									<th style={{ 'minWidth': '90px' }} className="text-end td-ellipsis" title={t('supplier_amount')}>{t('supplier_amount')}</th>
									<th style={{ 'minWidth': '120px' }} className="text-end">{t('amount')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.items?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>
											<ReactSelect
												uniqueId="select"
												search={handleSelectSearch}
												value={item.name}
												index={index}
												scrollRef={scrollRef}
												options={elements}
												onClose={() => closeReactSelect()}
												selectItem={(option) => handleSelectProduct(option, index)}
												onKeyUp={(e) => {
													if (e.keyCode === 40 || e.keyCode === 38) {
														handleTableKeyDown(e)
													}
												}}
												table={
													<table className="table mb-0">
														<tbody ref={tbodyRef}>
															{elements.map((selectItem, selectIndex) => (
																<tr
																	id={selectItem.id}
																	className={`cursor ${((selectItem.selected || selectItem.id === item.product_id) && 'selected')}`}
																	tabIndex={-1}
																	key={selectIndex}
																	onClick={() => handleSelectProduct(selectItem, index)}
																	onKeyDown={(e) => handleTableKeyDown(e, selectItem, index)}>
																	<td>{selectItem.name}</td>
																</tr>
															))}
														</tbody>
													</table>
												}
											/>
										</td>
										<td className="td-input">
											<input
												disabled={!(item.product_type === 2)}
												type="text"
												name="element_id"
												className="form-control text-end"
												placeholder="0"
												value={item.element_id}
												onChange={(e) => handleInputChange(e, index)} />
										</td>

										<td className="text-end text-nowrap vertical-middle">
											{formatMoney(item.balance)}
										</td>
										{/* <td>
											<ReactSelect
												tabIndex={-1}
												uniqueId="select2"
												search={handleSelectSearch}
												value={item.unit_name}
												index={index}
												scrollRef={scrollRef}
												options={item.units}
												onClose={() => closeReactSelect()}
												selectItem={(option) => handleSelectItemUnit(option, index)}
												onKeyUp={(e) => {
													if (e.keyCode === 40 || e.keyCode === 38) {
														handleTableKeyDown(e)
													}
												}}
												table={
													<table className="table mb-0">
														<tbody ref={tbodyRef}>
															{item?.units?.map((selectItem, selectIndex) => (
																<tr
																	id={selectItem.id}
																	className={`cursor ${((selectItem.selected || selectItem.id === item.unit_id) && 'selected')}`}
																	tabIndex={-1}
																	key={selectIndex}
																	onClick={() => handleSelectItemUnit(selectItem, index)}
																	onKeyDown={(e) => handleTableKeyDown(e, selectItem, index)}>
																	<td>{selectItem.name}</td>
																</tr>
															))}
														</tbody>
													</table>
												}
											/>
										</td> */}
										<td className="td-input">
											<input
												disabled={!(item.product_type === 2)}
												type="text"
												name="original_quantity"
												className="form-control text-end"
												placeholder="0"
												value={formatMoneyInput(item.original_quantity) ?? ''}
												onChange={(e) => handleInputChange(e, index)} />
										</td>
										<td className="td-input">
											<input
												// disabled={!(item.product_type === 2)}
												type="text"
												name="original_price"
												className="form-control text-end"
												placeholder="0"
												value={formatMoneyInput(item.original_price) ?? ''}
												onChange={(e) => handleInputChange(e, index)} />
										</td>
										<td className="td-input" style={!item.packaging_quantity ? { 'borderBottom': '2px solid red' } : {}}>
											<input
												type="text"
												name="packaging_quantity"
												className="form-control text-end"
												placeholder="0"
												value={formatMoneyInput(item.packaging_quantity) ?? ''}
												onChange={(e) => handleInputChange(e, index)} />
										</td>
										<td className="text-end text-nowrap vertical-middle td-disabled">
											{item.quantity ? formatMoney(Number(item.original_quantity ?? 0) / item.quantity * 1000, 2) : 0}
										</td>
										<td className="text-end text-nowrap vertical-middle td-disabled">
											{item.quantity ? formatMoney(item.quantity / Number(item.original_quantity)) : 0}
										</td>

										<td className="text-end">{item.quantity}</td>
										<td className="td-input">
											<input
												disabled={!(item.product_type === 2)}
												type="text"
												name="expense"
												className="form-control text-end"
												placeholder="0"
												value={formatMoneyInput(item.expense) ?? ''}
												onChange={(e) => handleInputChange(e, index)} />
										</td>
										{/* <td className="td-input" style={!item.supplier_price ? { 'borderBottom': '2px solid red' } : {}}>
											<input
												type="text"
												name="supplier_price"
												placeholder="0"
												className="form-control text-end"
												value={item.supplier_price ?? ''}
												onChange={(e) => handleInputChange(e, index)}
											/>
										</td> */}
										{item.product_type === 2 ?
											<td className="text-end" style={{ verticalAlign: 'middle' }}>
												{formatMoney(item.price)}
											</td>
											:
											<td className="td-input" style={!item.price ? { 'borderBottom': '2px solid red' } : {}}>
												<input
													type="text"
													name="price"
													placeholder="0"
													className="form-control text-end"
													value={formatMoneyInput(item.price) ?? ''}
													onChange={(e) => handleInputChange(e, index)}
												/>
											</td>
										}
										<td className="td-input" style={!item.wholesale_price ? { 'borderBottom': '2px solid red' } : {}}>
											<input
												type="text"
												name="wholesale_price"
												placeholder="0"
												className="form-control text-end"
												value={formatMoneyInput(item.wholesale_price) ?? ''}
												onChange={(e) => handleInputChange(e, index)}
											/>
										</td>
										<td className="td-input" style={!item.sale_price ? { 'borderBottom': '2px solid red' } : {}}>
											<input
												type="text"
												name="sale_price"
												placeholder="0"
												className="form-control text-end"
												value={formatMoneyInput(item.sale_price) ?? ''}
												onChange={(e) => handleInputChange(e, index)}
											/>
										</td>
										<td className="td-input">
											<input
												type="text"
												name="markup"
												placeholder="0"
												className="form-control text-end"
												value={item.markup ?? ''}
												onChange={(e) => handleInputChange(e, index)}
											/>
										</td>
										<td className="text-end">{formatMoney(item.total_supplier_price, 2)}</td>
										<td className="text-end">{formatMoney(item.total_price)}</td>
										<td className="vertical-middle">
											<div className="d-flex justify-content-end">
												<div className="table-action-button table-action-danger-button"
													onClick={() => deleteItem(index)}>
													<i className="uil uil-times"></i>
												</div>
											</div>
										</td>
									</tr>
								))}
								<tr className="tr-bold">
									<td></td>
									<td colSpan={1} style={{ 'padding': 0 }}>
										<div className="d-flex">
											<div className="w-100">
												<button type="button" className="btn-sm btn-primary w-100"
													disabled={!data.wms_id}
													onClick={() => addToList(1)}>
													{t('add')}
												</button>
											</div>
										</div>
									</td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td className="text-end">{formatMoney(data.total_amount_usd, 2)}</td>
									<td className="text-end">{formatMoney(data.total_amount)}</td>
									<td></td>
								</tr>
							</tbody>
						</table>

						<div className="w-100 d-flex justify-content-between d-none">
							<CustomTooltip text={t('annual_negative_values')}>
								<div className="d-flex justify-content-between">
									<p className="fw-600 vertical-center">{t('annual')}</p>
									<div className="form-check form-switch form-switch-lg flex-column justify-content-center">
										<input type="checkbox" className="form-check-input"
											name="bool_annual"
											checked={data?.bool_annual}
											onChange={(e) => setData({ ...data, 'bool_annual': e.target.checked })}
										/>
									</div>
								</div>
							</CustomTooltip>
						</div>

						<div className="btn-wrapper gap-2">
							<Link to="/documents-in" className="btn btn-warning btn-rounded btn-wide" tabIndex="-1">
								{t('cancel')}
							</Link>
							<button type="button" className="btn btn-primary btn-rounded btn-wide" tabIndex="-1"
								onClick={() => createUpdate(1)}>
								{t('save')}
							</button>
						</div>
					</div>
				</div>
			</form>

			{/* MODAL CONFIRM */}
			<Modal show={modalConfirm} animation={false} centered
				dialogClassName="update-modal-width" onHide={() => setModalConfirm(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('confirm')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="d-flex gap-2 w-100">
						<button className="btn btn-warning w-100"
							onClick={() => setModalConfirm(false)}>
							{t('cancel')}
						</button>
						<button className="btn btn-primary w-100"
							onClick={() => createUpdate(3)}>
							{t('confirm')}
						</button>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL CONFIRM */}
		</>
	)
}

export default CreateUpdate